export function getEnv(key: string): string | undefined {
  return import.meta.env[`VITE_${key}`];
}
